import { useState, useEffect } from "react";
import {
    FilterBarContainer,
    SearchContainer,
    StyledTextField,
    StyledSelect,
    StyledMenuItem,
    StyledButton,
    FullContainer,
    LeftBlock,
    RightBlock,
} from "./FilterBar.styles";
import { Dialog } from "@mui/material";
import CreateProductForm from "../CreateProductForm/CreateProductForm";

export default function FilterBar({ dropdowns = [], onChange, showNewButton = true, value = {} }) {
    const [searchText, setSearchText] = useState(value.search || "");
    const [dropdownValues, setDropdownValues] = useState(
        dropdowns.reduce((acc, dropdown) => {
        acc[dropdown.key] = value[dropdown.key] || "";
        return acc;
        }, {})
    );

    const [openDialog, setOpenDialog] = useState(false);

    // Update state when value prop changes
    useEffect(() => {
        setSearchText(value.search || "");
        const newDropdownValues = dropdowns.reduce((acc, dropdown) => {
            acc[dropdown.key] = value[dropdown.key] || "";
            return acc;
        }, {});
        setDropdownValues(newDropdownValues);
    }, [value, dropdowns]);

    const handleDropdownChange = (key, value) => {
        const newValues = { ...dropdownValues, [key]: value };
        setDropdownValues(newValues);
        if (onChange) onChange({ search: searchText, ...newValues });
    };

    const handleSearchChange = (text) => {
        setSearchText(text);
        if (onChange) onChange({ search: text, ...dropdownValues });
    };

    return (
        <FullContainer>
        <FilterBarContainer>
            <LeftBlock>
            <SearchContainer>
                <StyledTextField
                variant="standard"
                placeholder="Name, email, etc..."
                value={searchText}
                onChange={(e) => handleSearchChange(e.target.value)}
                InputProps={{ disableUnderline: true }}
                />
            </SearchContainer>
            </LeftBlock>

            <RightBlock>
            {dropdowns.map((dropdown) => (
                <div
                key={dropdown.key}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "8px",
                }}
                >
                <StyledSelect
                    value={dropdownValues[dropdown.key]}
                    onChange={(e) => handleDropdownChange(dropdown.key, e.target.value)}
                    displayEmpty
                    renderValue={(selected) => {
                    if (!selected)
                        return (
                        "Select " +
                        (dropdown.key.charAt(0).toUpperCase() + dropdown.key.slice(1))
                        );
                    const found = dropdown.options.find(
                        (opt) => opt.value === selected
                    );
                    return found ? found.label : "";
                    }}
                >
                    {dropdown.options.map((option) => (
                    <StyledMenuItem key={option.value} value={option.value}>
                        {option.label}
                    </StyledMenuItem>
                    ))}
                </StyledSelect>
                </div>
            ))}

            {showNewButton && (
                <StyledButton onClick={() => setOpenDialog(true)}>NEW</StyledButton>
            )}
            </RightBlock>
        </FilterBarContainer>

        <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            maxWidth="md"
            fullWidth
        >
            <CreateProductForm />
        </Dialog>
        </FullContainer>
    );
}
